<template>
  <CustomerComponent fromType="PROSPECT" :canCommand="false" :contactCanCommand="false" :invoiceCanCommand="false"/>
</template>
<script>
import { defineComponent } from 'vue'
import CustomerComponent from '../customerInfo/Index.vue'
export default defineComponent({
  name: 'Potentialcustomer',
  components: {
    CustomerComponent
  }
})
</script>
